import { render, staticRenderFns } from "./SalesOrderViewDeliveryState.vue?vue&type=template&id=e53318da&scoped=true"
import script from "./SalesOrderViewDeliveryState.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewDeliveryState.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderViewDeliveryState.vue?vue&type=style&index=0&id=e53318da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53318da",
  null
  
)

export default component.exports